<div class="row">
  <div class="col-leftnav">
    <p>
      <a href="#/doc-lib">Return to Document Library</a>
    </p>
  </div>
  <div class="col-md-11">
    <h1>Pricing Grids</h1>
    <hr />
    <div class="form-container">
      <div class="row">
        <div class="col-md-12">
          <ng-container *ngIf="pricingGridList && pricingGridList.length">
            <div *ngFor="let item of pricingGridList" style="margin-bottom: 1em">
              <a [href]="item.contentPath.replace('asPdf=false', 'asPdf=true')" target="_blank">{{ item.displayName }}</a>
            </div>
          </ng-container>
        </div>
        <p>
          <a href="#/doc-lib">Return to Document Library</a>
        </p>
      </div>
    </div>
  </div>
</div>
